import api from './api';

export default {
    index(page=1){
        return api.get(`${process.env.VUE_APP_URL}/users` , {params: {page:page}});
    },
    create(params){
        return api.post(`${process.env.VUE_APP_URL}/users` , params);
    },
    show(id){
        return api.get(`${process.env.VUE_APP_URL}/users/${id}`);
    },
    update(id , params){
        return api.put(`${process.env.VUE_APP_URL}/users/${id}` , params);
    },
    delete(id){
        return api.delete(`${process.env.VUE_APP_URL}/users/${id}`);
    },
}